import { createContext } from "react";

const PreferencesDataContext = createContext(null);

export default PreferencesDataContext;